import { getPatientsAnswers, getPatientsStat } from "@/api/group";
import MembersImg from "@/assets/image/members.png";
import ClockIcon from "@/assets/SVG/clockIcon";
import { Modal } from "@/components";
import InlineLoader from "@/components/loader/InlineLoader";
import CustomizedHook from "@/components/project/autocomplatePro";
import Card from "@/pages/admin/dashboard/components/Card";
import { Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

function PatientsStat({ patientsStat, allTripsInfo }) {
  const [tripFilterOptions, setTripFilterOptions] = useState([]);
  const [areaFilterOptions, setAreaFilterOptions] = useState([]);
  const [moduleFilterOptions, setModuleFilterOptions] = useState([]);

  const [selectedTrip, setSelectedTrip] = useState(undefined);
  const [selectedArea, setSelectedArea] = useState(undefined);
  const [selectedModule, setSelectedModule] = useState(undefined);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [servicesStat, setServicesStat] = useState();
  const [refreshTime2, setRefreshTime2] = useState();
  const [refreshTime1, setRefreshTime1] = useState();

  const md = useMediaQuery("(max-width:450px)");

  const [filteredTripsStats, setFilteredTripsStats] = useState([]);

  useEffect(() => {
    setFilteredTripsStats(patientsStat);
  }, [patientsStat]);

  const fetchPatientsAnswers = useCallback(
    (forceReload) => {
      setLoading2(true);
      if (selectedModule === undefined || selectedModule === "") return;

      const params = new URLSearchParams();
      if (selectedArea !== undefined && selectedArea !== "") {
        params.append(
          "areaId",
          areaFilterOptions.find((e) => e.value === selectedArea)?.key,
        );
      }
      if (selectedTrip !== undefined && selectedTrip !== "") {
        params.append(
          "tripId",
          tripFilterOptions.find((e) => e.value === selectedTrip)?.key,
        );
      }
      if (forceReload) {
        params.append("forceReload", true);
      }

      getPatientsAnswers(
        moduleFilterOptions.find((e) => e.value === selectedModule)?.key,
        params.toString(),
      )
        .then((res) => {
          setServicesStat(res.data);
          setRefreshTime2(res.refreshTime);
        })
        .catch((_) => {})
        .finally(() => setLoading2(false));
    },
    [moduleFilterOptions, selectedModule],
  );

  useEffect(() => {
    if (selectedModule === undefined) return;
    fetchPatientsAnswers(false);
  }, [selectedModule]);

  useEffect(() => {
    if (!allTripsInfo?.length) {
      setTripFilterOptions([]);
      setAreaFilterOptions([]);
      setModuleFilterOptions([]);
      return;
    }

    const trips = [
      ...new Set(
        allTripsInfo
          .map((item) => item.tripName + "_" + item.tripId)
          .filter(Boolean),
      ),
    ];

    setTripFilterOptions([
      ...trips.map((e) => {
        const tmp = e.split("_");
        return { key: tmp[1], value: tmp[0] };
      }),
      { key: "همه", value: "همه" },
    ]);

    const areas = [
      ...new Set(
        allTripsInfo
          .filter((item) => !selectedTrip || item.tripName === selectedTrip)
          .map((item) => item.name + "_" + item.id)
          .filter(Boolean),
      ),
    ];

    setAreaFilterOptions([
      ...areas.map((e) => {
        const tmp = e.split("_");
        return { key: tmp[1], value: tmp[0] };
      }),
      { key: "همه", value: "همه" },
    ]);

    const modules = [
      ...new Set(
        allTripsInfo
          .filter(
            (item) =>
              (!selectedTrip || item.tripName === selectedTrip) &&
              (!selectedArea || item.name === selectedArea),
          )
          .flatMap(
            (item) =>
              item.moduleStats?.map(
                (module) => module.name + "_" + module.id,
              ) ?? [],
          )
          .filter(Boolean),
      ),
    ];

    setModuleFilterOptions([
      ...modules.map((e) => {
        const tmp = e.split("_");
        return { key: tmp[1], value: tmp[0] };
      }),
      { key: "همه", value: "همه" },
    ]);

    if (selectedArea && !areas.includes(selectedArea)) {
      setSelectedArea("");
      setSelectedModule("");
      return;
    }

    if (selectedModule && !modules.includes(selectedModule)) {
      setSelectedModule("");
    }
  }, [allTripsInfo, selectedTrip, selectedArea]);

  const fetchPatientsStat = useCallback(
    (forceReload) => {
      setLoading1(true);
      const params = new URLSearchParams();

      if (selectedArea !== undefined && selectedArea !== "") {
        params.append(
          "areaId",
          areaFilterOptions.find((e) => e.value === selectedArea)?.key,
        );
      }
      if (selectedTrip !== undefined && selectedTrip !== "") {
        params.append(
          "tripId",
          tripFilterOptions.find((e) => e.value === selectedTrip)?.key,
        );
      }
      if (forceReload) {
        params.append("forceReload", true);
      }

      if (selectedModule !== undefined && selectedModule !== "") {
        params.append(
          "moduleId",
          moduleFilterOptions.find((e) => e.value === selectedModule)?.key,
        );
      }
      getPatientsStat(params.toString())
        .then((res) => {
          setFilteredTripsStats(res);
          setRefreshTime1(res.refreshAt);
        })
        .catch((_) => {})
        .finally(() => setLoading1(false));
    },
    [
      selectedModule,
      selectedArea,
      selectedTrip,
      tripFilterOptions,
      areaFilterOptions,
      moduleFilterOptions,
    ],
  );

  useEffect(() => {
    if (selectedModule === "" && selectedArea === "" && selectedTrip === "") {
      setFilteredTripsStats(patientsStat);
      return;
    }
    fetchPatientsStat(false);
  }, [selectedModule, selectedArea, selectedTrip]);

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"10px"}
        width={"100%"}
      >
        <Grid
          display={"flex"}
          flexDirection={"row"}
          gap={"10px"}
          alignItems={"center"}
        >
          <Typography>{`تاریخ آخرین به روزرسانی ${refreshTime1 ?? "-"}`}</Typography>
          {!loading1 && (
            <IconButton onClick={() => fetchPatientsStat(true)}>
              <ClockIcon />
            </IconButton>
          )}
        </Grid>
        <Grid
          display="flex"
          flexDirection={md ? "column" : "row"}
          gap="10px"
          flexWrap="wrap"
          width={"100%"}
        >
          <CustomizedHook
            parentWidth={md ? "100%" : "170px"}
            width={md ? "100%" : "170px"}
            maxWidth={md ? "100%" : "170px"}
            placeholder={"اردو"}
            label="اردو"
            options={tripFilterOptions}
            onChange={(_, newValue) =>
              setSelectedTrip(
                newValue.value === "همه" ? undefined : newValue.value,
              )
            }
            value={
              selectedTrip === undefined
                ? "همه"
                : tripFilterOptions.find((e) => e.value === selectedTrip) ||
                  null
            }
          />
          <CustomizedHook
            parentWidth={md ? "100%" : "170px"}
            width={md ? "100%" : "170px"}
            maxWidth={md ? "100%" : "170px"}
            placeholder={"منطقه"}
            label="منطقه"
            options={areaFilterOptions}
            onChange={(_, newValue) =>
              setSelectedArea(
                newValue.value === "همه" ? undefined : newValue.value,
              )
            }
            value={selectedArea === undefined ? "همه" : selectedArea || null}
          />
          <CustomizedHook
            parentWidth={md ? "100%" : "170px"}
            width={md ? "100%" : "170px"}
            maxWidth={md ? "100%" : "170px"}
            placeholder={"بخش"}
            label="بخش"
            options={moduleFilterOptions}
            onChange={(_, newValue) =>
              setSelectedModule(
                newValue.value === "همه" ? undefined : newValue.value,
              )
            }
            value={
              selectedModule === undefined ? "همه" : selectedModule || null
            }
          />
        </Grid>
        <Grid
          display={"flex"}
          flexDirection={md ? "column" : "row"}
          gap={"10px"}
          width={"100%"}
          flexWrap={"wrap"}
        >
          {!md && (
            <Modal width={md ? "100%" : "calc(100% - 560px)"}>
              <Grid
                display={"flex"}
                flexDirection={"column"}
                gap={"15px"}
                justifyContent={"space-between"}
                height={"100%"}
              >
                <Grid display={"flex"} flexDirection={"column"}>
                  <img
                    height={"100px"}
                    width={"fit-content"}
                    src={MembersImg}
                    style={{ margin: "15px auto" }}
                  />
                  <Typography variant="h6" sx={{ color: "var(--emr-text)" }}>
                    لیست مراجعین
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--emr-primary-color-text)",
                      marginTop: "10px",
                    }}
                  >
                    شما میتوانید لیست کل بیماران گروه خود را مشاهده و مدیریت
                    کنید.
                  </Typography>
                </Grid>
                <Typography
                  sx={{ color: "var(--emr-primary)", cursor: "pointer" }}
                >
                  مشاهده
                </Typography>
              </Grid>
            </Modal>
          )}

          <Grid
            display="flex"
            flexDirection="row"
            gap="20px"
            width={md ? "100%" : "540px"}
            flexWrap={"wrap"}
          >
            {loading1 ? (
              <InlineLoader />
            ) : (
              <>
                <Card
                  title={"کل مراجعین"}
                  width={md ? "100%" : "250px"}
                  sx={{ height: "100px" }}
                  counter={filteredTripsStats.total}
                  unit={"نفر"}
                />
                <Card
                  title={"کل مراجعین کودک"}
                  width={md ? "100%" : "250px"}
                  sx={{ height: "100px" }}
                  counter={filteredTripsStats.child}
                  unit={"نفر"}
                />
                <Card
                  title={"کل مراجعین مرد"}
                  width={md ? "100%" : "250px"}
                  sx={{ height: "100px" }}
                  counter={filteredTripsStats.male}
                  unit={"نفر"}
                />
                <Card
                  title={"کل مراجعین زن"}
                  width={md ? "100%" : "250px"}
                  sx={{ height: "100px" }}
                  counter={filteredTripsStats.female}
                  unit={"نفر"}
                />
              </>
            )}
          </Grid>
        </Grid>

        <Typography my={"10px"}>
          برای نمایش آمار تفکیکی خدمات داده شده باید حتما از فیلتر "بخش" استفاده
          کنید
        </Typography>
        {servicesStat && (
          <Grid
            display={"flex"}
            flexDirection={"column"}
            mt={"20px"}
            gap={"20px"}
          >
            <Grid
              display={"flex"}
              flexDirection={"row"}
              gap={"10px"}
              alignItems={"center"}
            >
              <Typography>{`تاریخ آخرین به روزرسانی ${refreshTime2 ?? "-"}`}</Typography>
              {!loading2 && (
                <IconButton onClick={() => fetchPatientsAnswers(true)}>
                  <ClockIcon />
                </IconButton>
              )}
            </Grid>

            {loading2 ? (
              <InlineLoader />
            ) : (
              <Grid
                display={"flex"}
                flexDirection={"row"}
                flexWrap={"wrap"}
                gap={"15px"}
                rowGap={"20px"}
              >
                {servicesStat.map((service) => (
                  <>
                    {service.optionsDigest.map((option, index) => (
                      <Card
                        key={index}
                        title={service.text}
                        counter={option.counter}
                        additionalChild={
                          <Typography color="primary" variant="body1">
                            {option.option.value}
                          </Typography>
                        }
                      />
                    ))}
                  </>
                ))}
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default PatientsStat;
